var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIotOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 81 62",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1138,-729)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,197.157,-1135.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.142134,0,0,0.0804551,743.281,927.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iot"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.02318,0,0,7.25777,-851.888,-5848.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.67,
    y: 928.815,
    width: 84.611,
    height: 52.197,
    style: {
      fill: "white",
      stroke: "rgb(255,104,52)",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1313.95,985.956L1335.94,985.944",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.04,985.915L1530.15,985.834",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.20733,-0.991926)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1366.7,
    cy: 986.826,
    r: 25.547,
    style: {
      fill: "white",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.82121e-13,184.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1313.95,985.956L1335.94,985.944",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.04,985.915L1530.15,985.834",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.20733,-0.991926)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1366.7,
    cy: 986.826,
    r: 25.547,
    style: {
      fill: "white",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.22465e-16,-1.22465e-16,-1,2844.1,2067.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1313.95,985.956L1335.94,985.944",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.04,985.915L1530.15,985.834",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.20733,-0.991926)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1366.7,
    cy: 986.826,
    r: 25.547,
    style: {
      fill: "white",
      stroke: "rgb(255,104,52)",
      strokeWidth: "26.71px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer5",
    transform: "matrix(6.85322,0,0,6.74213,-5629.69,-1938.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.03,446.322L993.913,435.83L1000.19,430.395L1007.08,436.08L1007.1,446.192L994.03,446.322Z",
    style: {
      fill: "white",
      stroke: "rgb(255,104,52)",
      strokeWidth: "3.93px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.705234,0.250911,0.255146,0.782815,181.771,-154.727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M990.943,438.358L993.913,435.83",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "3.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.775352,0.191225,-0.194453,0.834478,1862.16,-117.921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M990.943,438.358L993.913,435.83",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "3.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.949276,0,0,1,50.7855,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.996,446.322L1008.98,446.322",
    style: {
      fill: "none",
      stroke: "rgb(255,104,52)",
      strokeWidth: "4.03px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.375811,0,0,0.951696,626.6,21.8264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 993.21,
    y: 438.754,
    width: 3.686,
    height: 5.702,
    style: {
      fill: "white",
      stroke: "rgb(255,104,52)",
      strokeWidth: "5.45px"
    }
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotOutline);
export default __webpack_public_path__ + "static/media/iotOutline.a91f335f6601d58852b402b115f0cd7f.svg";
export { ForwardRef as ReactComponent };